import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';

export const CertificatesTab = (mainTabLabel: any) => {
    const router = useNavigate();

    const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';

    const HRitems: MenuItem[] = [
        {
            label: 'Provisional Certificate',
            command: () => {
                router('/app/certificate/provisional-certificate');
            }
        },
        {
            label: 'Original Certificate',
            command: () => {
                router('/app/certificate/original-certificate');
            }
        },
        {
            label: 'Duplicate Certificate',
            command: () => {
                router('/app/certificate/duplicate-certificate');
            }
        },
        {
            label: 'Additional Certificate',
            command: () => {
                router('/app/certificate/additional-certificate');
            }
        },
        {
            label: 'Good Standing Certificate',
            command: () => {
                router('/app/certificate/goodstanding-certificate');
            }
        },
        {
            label: 'Registration Date Update',
            command: () => {
                router('/app/certificate/registration-date-update');
            }
        }
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    // Convert string to Set
    const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

    // Filter HRitems by checking if label exists in assignedMenuSet
    const filteredHRitems = HRitems.filter((item) => item.label && assignedMenuSet.has(item.label));

    useEffect(() => {
        if (filteredHRitems.length > 0 && mainTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == mainTabLabel.mainTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />
        </>
    );
};
